<div class="outer-container">
   <div class="button-grid">
      <div class="button-container">
         <button
            pButton
            label="Test Messaging"
            (click)="sendTestMessaging()"
            [disabled]="isSendingMessages"></button>

         <ng-container *ngIf="isSendingMessages">
            <span class="sending-text">Sending Messages, please wait...</span>
         </ng-container>
      </div>

      <div class="button-container">
         <p-calendar
            [(ngModel)]="selectedDate"
            dateFormat="yy-mm-dd"
            showIcon="true"
            (onSelect)="getMessagesByDate(selectedDate)"></p-calendar>
      </div>
   </div>

   <ng-container *ngIf="!hasMessagesToShow && !isSendingMessages">
      <span class="sending-text">No Messages for this Date</span>
   </ng-container>

   <ng-container *ngIf="hasMessagesToShow">
      <span class="sending-text">{{ filteredMessages.length }} Messages for this Date</span>
   </ng-container>

   <ng-container *ngIf="isSendingMessages">
      <p-progressSpinner></p-progressSpinner>
   </ng-container>

   <ng-container *ngIf="hasMessagesToShow">
      <div class="filter-container">
         <input
            type="text"
            placeholder="Filter by phone or name"
            [(ngModel)]="filterText"
            (ngModelChange)="filterMessages()" />
      </div>
   </ng-container>

   <div class="messages-container">
      <div
         *ngFor="let message of filteredMessages"
         [ngClass]="{ outgoing: message.isOutgoing, incoming: !message.isOutgoing }"
         class="message-card">
         <div class="message-info">
            <span class="phone">{{ message.phone || "Unknown Number" }}</span>
            <span class="name">{{ message.firstName }} {{ message.lastName }}</span>
            <span class="timestamp">{{ message.timestamp | date : "MMM d, y, h:mm a" }}</span>
         </div>
         <div class="message-text">
            <pre>{{ message.messageText }}</pre>
         </div>
      </div>
   </div>
</div>
